import { z } from 'zod';

import { PrimaryKeySchema, commaDelimitedList } from './utils';

export const SearchEngineResultSchema = z.object({
  searchEngineResultId: PrimaryKeySchema,
  searchEngineRequestId: PrimaryKeySchema,
  title: z.string(),
  url: z.string().url(),
  createdAt: z.coerce.date(),
});

export type SearchEngineResult = z.infer<typeof SearchEngineResultSchema>;

export const SearchEngineResultsSchema = z.array(SearchEngineResultSchema);

export type SearchEngineResults = z.infer<typeof SearchEngineResultsSchema>;

export const SearchEngineResultsQuerySchema = z.object({
  searchEngineRequestIds: commaDelimitedList(
    PrimaryKeySchema.array(),
  ).optional(),
  searchEngineResultIds: commaDelimitedList(
    PrimaryKeySchema.array(),
  ).optional(),
});

export type SearchEngineResultsQuery = z.infer<
  typeof SearchEngineResultsQuerySchema
>;
